import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { permissionsAPI } from '../services/api';
import './Users.css';

const Permissions = () => {
  const [roles, setRoles] = useState([]);
  const [perms, setPerms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const [rolesRes, permissionsRes] = await Promise.all([
          permissionsAPI.getRoles(),
          permissionsAPI.getPermissions(),
        ]);
        if (!cancelled) {
          setRoles(rolesRes.data || []);
          setPerms(permissionsRes.data || []);
        }
      } catch (error) {
        if (!cancelled) {
          toast.error(
            'Error loading permissions data: ' + (error.response?.data?.message || error.message)
          );
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return <div className="loading">Loading permissions...</div>;
  }

  return (
    <div className="users-container">
      <div style={{ marginBottom: '20px' }}>
        <Link to="/permissions/manage" className="btn btn-primary" style={{ display: 'inline-block' }}>
          Manage user permissions
        </Link>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '30px' }}>
        <div className="card">
          <h3>Roles ({roles.length})</h3>
          <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
            {roles.map((role) => (
              <div key={role.id} style={{ padding: '10px', borderBottom: '1px solid #eee' }}>
                <strong>{role.name}</strong>
                {role.permissions && role.permissions.length > 0 && (
                  <div style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
                    Permissions: {role.permissions.map((p) => p.name).join(', ')}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="card">
          <h3>Permissions ({perms.length})</h3>
          <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
            {perms.map((permission) => (
              <div key={permission.id} style={{ padding: '10px', borderBottom: '1px solid #eee' }}>
                <strong>{permission.name}</strong>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Permissions;
